<template>
  <div style="margin-top: 30px">
    <el-tabs type="border-card">
      <el-tab-pane label="账户明细">
        <div class="box">
          <div class="account-box">
            <div class="img-box">
              <img src="../../../assets/home_images/wallet.png">
            </div>
            <div class="account">
              账户余额
              <span>{{ form.balance }}元</span>
            </div>
          </div>

          <div class="info-box">
            <div class="line" />
            <div class="info1-box">
              <div class="lable">企业名称:</div>
              <div class="lable">账号信息:</div>
            </div>
            <div>
              <div>{{ form.groupName }}</div>
              <div>{{ form.merchantId }}</div>
            </div>
          </div>
        </div>

        <vxe-toolbar id="toolbarId_sy9" :custom="{ storage: true }" export :refresh="{ query: RefreshList }">
          <template v-slot:buttons>
            <el-button v-if="getLimit('accountDetail_search_button')" @click="funcFilter">
              查询
            </el-button>
            <el-button v-if="getLimit('accountDetail_export_button')" @click="funcExport">
              导出
            </el-button>
            <el-button v-if="getLimit('accountDetail_sumDownload_button')" type="primary" @click="download()">
              下载汇总对账单
            </el-button>
          </template>
        </vxe-toolbar>
        <vxe-table
          ref="xTable"
          border
          highlight-hover-row
          row-id="id"
          height="420"
          :data="tableData"
          :sort-config="{ remote: true }"
          export-config
          show-overflow
          align="center"
        >
          <vxe-table-column type="checkbox" width="60" fixed="left" />
          <vxe-table-column field="tradingTime" title="交易日期" min-width="100" sortable />
          <vxe-table-column>
            <vxe-table-column field="receiptNo" title="电子回单编号" min-width="100" sortable />
            <template v-slot:header>
              <el-input v-model="listQuery.receiptNo" placeholder="请输入" clearable />
            </template>
          </vxe-table-column>
          <vxe-table-column>
            <vxe-table-column field="outTradeNo" title="交易流水号" min-width="100" sortable />
            <template v-slot:header>
              <el-input v-model="listQuery.outTradeNo" placeholder="请输入" clearable />
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作" fixed="right">
            <template slot-scope="scope">
              <el-tooltip v-if="getLimit('accountDetail_download_button') && scope.row.status =='02'" class="item" effect="dark" content="下载凭证" placement="top">
                <vxe-button type="text" @click="showElectronicReceipt(scope.row)">
                  <i class="el-icon-download" />
                </vxe-button>
              </el-tooltip>
              <el-tooltip v-if="getLimit('accountDetail_refresh_button') && scope.row.status =='01'" class="item" effect="dark" content="刷新" placement="top">
                <vxe-button type="text" @click="statusQuery(scope.row)">
                  <i class="el-icon-refresh" />
                </vxe-button>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-pager
          :loading="loading"
          :current-page.sync="listQuery.pageNum"
          :page-size.sync="listQuery.pageSize"
          :page-sizes="Pagingconf"
          :total="listQuery.total"
          :layouts="[
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total',
          ]"
          @page-change="handlePageChange"
        />
      </el-tab-pane>
    </el-tabs>

    <vxe-modal v-model="modelFlag" title="汇总详情" width="1000" resize>
      <statementAccount ref="accountRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
import statementAccount from "./components/statementAccount";  
import {
  mybankElectronicReceipt,
  mybankElectronicReceiptInfo,
  electronicReceiptQuery,
} from "@/api/InternetBanking";
export default {
  name: "AccountDetail",
  components: {
    statementAccount,
  },
  data() {
    return {
      branchCode: "",
      code: "",
      tableData: [],
             exportObj:{
        exportUrl:"/ntocc-tms-api/mybankElectronicReceipt/exportAccountDetailList",//导出接口
        name:'账户明细'
        },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "tradingTime",
        sortType: "desc",
      },
      loading: false,
      modelFlag: false,
      form: {},
    };
  },
  created() {
    // this.getInfo(this.$route.query.code);
    this.findList();
  },
  methods: {
    getInfo(branchCode) {
      return request({
        url: `/ntocc-tms-api/mybankMerchant/platformQueryBalance/${branchCode}`,
        method: "get",
      }).then((response) => {
        if (response.data) {
          this.form = response.data;
        }
      });
    },
    findList() {
      if(this.form.groupName==undefined) {
        this.getInfo(this.$route.query.code)
      }
      this.listQuery.branchCode = this.$route.query.code;
      this.loading = true;
      return new Promise((resolve) => {
        mybankElectronicReceipt(this.listQuery, "get").then((response) => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    showElectronicReceipt(row) {
      mybankElectronicReceiptInfo(row.receiptNo)
        .then((res) => {
          let url = res.data.pdfDownloadUrl;
          window.open(url, "_blank");
        })
        .catch((res) => {});
    },
    //更新申请结果
    statusQuery(row) {
      const rLoading = this.openLoading();
      electronicReceiptQuery(row.receiptNo).then((response) => {
        rLoading.close();
        let type = response.status === 0 ? "success" : "error";
        this.findList();
        this.$message({
          message: response.msg,
          type: type,
        });
      });
    },
    download() {
      this.$refs.accountRef.findList();
      this.modelFlag = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.box {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;

  .account-box {
    display: flex;
    align-items: center;
    padding: 20px;
    margin-right: 20px;
    .account {
      flex-direction: column;
      margin-left: 20px;
      display: flex;
      span {
        font-size: 28px;
        color: #096ddd;
      }
    }
  }

  .info-box {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 40px;
    padding-left: 50px;
    position: relative;
    .lable {
      font-size: 17px;
      margin-right: 5px;
    }
    .line {
      width: 1px;
      height: 60px;
      background: #e6e5e5;
      position: absolute;
      top: 25%;
      left: 0;
    }
  }
}
</style>
